import { isEscape, returnFocus, trapFocus, debounce } from "./utils.js";

const BREAKPOINT = 992;
const navToggle = document.getElementById('navbar-toggle');
const nav = document.getElementById('primary-navigation');
const submenuToggles = document.querySelectorAll('.menu-item-has-children > a');
const submenus = document.querySelectorAll('.sub-menu');

function hide(el) {
    el.classList.remove('show');
    el.setAttribute('aria-hidden', true);
}
function collapse(el) {
    el.classList.remove('show');
    el.setAttribute('aria-expanded', false);
}

function show(el) {
    el.classList.add('show')
    el.setAttribute('aria-hidden', false);
}
function expand(el) {
    el.classList.add('show');
    el.setAttribute('aria-expanded', true);
}

function initNavigation() {
    if (window.outerWidth >= BREAKPOINT) {
        show(nav);
        submenus.forEach(el => {
            hide(el);
        });
        submenuToggles.forEach(el => {
            collapse(el);
        })
    } else {
        collapse(navToggle);
        hide(nav);
    }
}

// Handle mobile toggle click
navToggle.addEventListener('click', e => {
    if (window.outerWidth >= BREAKPOINT) {
        return;
    }
    if (navToggle.getAttribute('aria-expanded') === 'true') {
        collapse(navToggle);
        hide(nav);
        submenus.forEach(el => hide(el));
        submenuToggles.forEach(el => collapse(el));
    } else {
        show(nav);
        expand(navToggle);
    }
});

// Handle dropdown toggle click for mobile and ADA
submenuToggles.forEach(el => {
    el.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();

        const menu = el.closest('li').querySelector('.sub-menu');
        if (el.getAttribute('aria-expanded') === 'true') {
            collapse(el);
            hide(menu);
        } else {
            expand(el);
            show(menu);
            trapFocus(menu, false);
            window.returnFocusTo = el;
        }
    });
})

// Collapse dropdowns when clicking outside
document.addEventListener('click', e => {
    submenus.forEach(el => hide(el));
    submenuToggles.forEach(el => collapse(el));
});

// ADA
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        submenus.forEach(el => hide(el));
        submenuToggles.forEach(el => collapse(el));
        returnFocus();
    }
});

// Ensure ARIA roles and element visibility are set correctly on page load and window resize
initNavigation();
window.addEventListener('resize', debounce(() => {
    initNavigation();
}, 300));
